import React from 'react';
import PropTypes from 'prop-types';

import { Box, Text } from '../../../Theme';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Text
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </Text>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default TabPanel;
